import { z as zod } from 'zod'
import * as Yup from 'yup'

import { DefaultSchemas } from './defaultSchemas'

export const CorporateContactsDefaultSchemas = DefaultSchemas

export const CorporateContactsDataSchemas = zod.object({
  contactId: zod.number().optional(),
  traderId: zod.number().optional(),
  titleId: zod.number().nullable().optional(),
  titleName: zod.string().nullable().optional(),
  firstName: zod.string().nullable().optional(),
  middleNames: zod.string().nullable().optional(),
  lastName: zod.string().nullable().optional(),
  phone1: zod.string().nullable().optional(),
  phone2: zod.string().nullable().optional(),
  fax1: zod.string().nullable().optional(),
  fax2: zod.string().nullable().optional(),
  email: zod.string().nullable().optional(),
  mobile: zod.string().nullable().optional(),
  comments: zod.string().nullable().optional(),
  isPrimary: zod.boolean().optional(),
  isActive: zod.boolean().optional(),
})

export const CorporateContactsAPISchemas = CorporateContactsDefaultSchemas.merge(
  zod.object({
    data: zod.array(CorporateContactsDataSchemas),
  })
)

export const AddCorporateContactsAPISchemas = CorporateContactsDefaultSchemas
export const UpdateCorporateContactsAPISchemas = CorporateContactsDefaultSchemas

export const CorporateContactsFetchParamsSchemas = zod.object({
  traderId: zod.number(),
})

export const AddCorporateContactsFetchParamsSchemasYup = Yup.object({
  traderId: Yup.number().required('Trader ID is required'),
  firstName: Yup.string().required('First name is required').nullable(),
  lastName: Yup.string().nullable(),
  middleNames: Yup.string().nullable(),
  phone1: Yup.string().nullable(),
  phone2: Yup.string().nullable(),
  fax1: Yup.string().nullable(),
  fax2: Yup.string().nullable(),
  email: Yup.string().nullable(),
  mobile: Yup.string().nullable(),
  comments: Yup.string().nullable(),
  isPrimary: Yup.boolean(),
  isActive: Yup.boolean(),
})

export const UpdateCorporateContactsFetchParamsSchemasYup = Yup.object({
  contactId: Yup.number().required('Contact ID is required'),
  traderId: Yup.number().required('Trader ID is required'),
  firstName: Yup.string().nullable(),
  lastName: Yup.string().nullable(),
  middleNames: Yup.string().nullable(),
  phone1: Yup.string().nullable(),
  phone2: Yup.string().nullable(),
  fax1: Yup.string().nullable(),
  fax2: Yup.string().nullable(),
  email: Yup.string().nullable(),
  mobile: Yup.string().nullable(),
  comments: Yup.string().nullable(),
  isPrimary: Yup.boolean(),
  isActive: Yup.boolean(),
})
